import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';

const styles = require('./../MailListHeader.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MailListActionHeaderThirdRowProps {
    containerCssClass: string;
    text: string;
    onClick?: (evt: React.MouseEvent<unknown>, folderId: string) => void;
    distinguishedFolderId?: string;
    showBackArrow?: boolean;
    showLoadingSpinner?: boolean;
}

@observer
export default class MailListActionHeaderThirdRow extends React.Component<
    MailListActionHeaderThirdRowProps,
    {}
> {
    handleClick = evt => {
        this.props.onClick(evt, this.props.distinguishedFolderId);
    };
    render() {
        return (
            <div className={this.props.containerCssClass}>
                {this.props.onClick ? this.renderLink() : this.renderPlainText()}
            </div>
        );
    }

    private renderLink = () => {
        return (
            <Link
                onClick={this.handleClick}
                className={styles.actionHeaderThirdRow}
                title={this.props.text}>
                {this.props.showBackArrow && (
                    <Icon
                        iconName={ControlIcons.ChevronLeft}
                        className={classNames(styles.linkIcon, 'flipForRtl')}
                    />
                )}
                <span className={styles.actionHeaderThirdRowText}>{this.props.text}</span>
                {this.props.showLoadingSpinner && (
                    <Spinner className={styles.spinner} size={SpinnerSize.small} />
                )}
            </Link>
        );
    };

    private renderPlainText = () => {
        return (
            <span className={styles.actionHeaderThirdRowText} title={this.props.text}>
                {this.props.text}
            </span>
        );
    };
}
